import { useIntl } from 'react-intl';

import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';
import { IconArrowRight } from '@xing-com/icons';

import { SPECIAL_CHARACTER_ID, SPECIAL_CHARACTER_LABEL } from './constants';
import {
  StyledColumn,
  StyledHeadline,
  StyledButton,
  NamesContainer,
  HelperText,
  StyledTextButton,
} from './top-level-page-link.styles';

export type TopLevelPageLinkProps = {
  title: string;
  url: string;
  exampleNames?: { name: string; url: string }[];
};

export const TopLevelPageLink: React.FC<TopLevelPageLinkProps> = ({
  title,
  url,
  exampleNames,
}) => {
  const { formatMessage } = useIntl();
  const formattedUrl = sanitizeUrl(url);

  return (
    <StyledColumn sizeConfined={4} size={6} sizeWide={3}>
      <StyledHeadline
        $isLetter={title.length === 1 || title === SPECIAL_CHARACTER_ID}
      >
        <a href={formattedUrl}>
          {title !== SPECIAL_CHARACTER_ID ? title : SPECIAL_CHARACTER_LABEL}
        </a>
      </StyledHeadline>
      {exampleNames && exampleNames.length > 0 ? (
        <NamesContainer>
          <HelperText>{formatMessage({ id: 'PD_200_NAMES_LIKE' })} </HelperText>
          {exampleNames.map(({ name, url }, index) => (
            <StyledButton key={`${name}-${index}`} href={sanitizeUrl(url)}>
              {name}
            </StyledButton>
          ))}
        </NamesContainer>
      ) : null}
      <StyledTextButton
        iconAfter
        icon={IconArrowRight}
        size="small"
        ellipsis
        href={formattedUrl}
      >
        {formatMessage({ id: 'PD_USER_BAG_COMPONENT_BUTTON_LABEL' })}
      </StyledTextButton>
    </StyledColumn>
  );
};
